import { makeStyles, useMediaQuery } from '@material-ui/core';
import { mdiAccountCog, mdiChevronLeftBox, mdiHome, mdiHospitalBuilding, mdiMenu, mdiPhone } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { Link } from 'react-router-dom';
// import { Link } from 'react-scroll'

function Header({ handleDrawer, isDrawer }) {

    const mobile = useMediaQuery('(max-width: 500px)')
    const styles = useStyles({ mobile });

    return (

        <div className={styles.headerContainer}>

            <Link to='/' className={styles.link}>
                <div className={styles.brand}> <Icon className={styles.headerIcon} path={mdiHospitalBuilding} size='1.5rem' />EVA Healthcare</div>
            </Link>

            {isDrawer
                ?
                <div className={styles.menu}><Icon className={styles.headerIcon} path={mdiChevronLeftBox} size='1.8rem' onClick={handleDrawer} /></div>
                :
                <div className={styles.menu}><Icon className={styles.headerIcon} path={mdiMenu} size='1.8rem' onClick={handleDrawer} /></div>
            }

            <div className={styles.navigation}>
                <Link to='/' className={styles.link}>
                    <a href="#work" className={styles.navItem}> <Icon className={styles.headerIcon} path={mdiHome} size='1.4rem' /> Home</a>
                </Link>

                {/* <Link to='' className={styles.link}>
                    <a href="#contact" className={styles.navItem}> <Icon className={styles.headerIcon} path={mdiPhone} size='1.8rem' /> About Us</a>
                </Link> */}
            </div>
        </div>
    )
}

export default Header

const useStyles = makeStyles(({
    headerContainer: ({ mobile }) => mobile ? {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px',
        backgroundColor: '#33658A',
        color: '#FFFFF2',
        fontSize: '1.2rem',
        fontWeight: '600',
        position: 'fixed',
        top: '0',
        width: '95%',
        zIndex: '10'
    } : {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px',
        backgroundColor: '#39393A',
        color: '#FFFFF2',
        fontSize: '1.2rem',
        fontWeight: '600',
        position: 'fixed',
        top: '0',
        width: '100%',
        zIndex: '10'
    },
    brand: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        marginLeft: '20px',
        '&:hover': {
            color: '#E4FDE1'
        }
    },
    menu: ({ mobile }) => mobile ? {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
            color: '#E4FDE1'
        }
    } : {
        display: 'none'
    },
    navigation: ({ mobile }) => mobile ? {
        display: 'none'
    } : {
        display: 'flex',
        alignItems: 'center',
        marginRight: '40px'
    },
    navItem: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 20px',
        cursor: 'pointer',
        textDecoration: 'none',
        color: '#FFFFF2',
        '&:hover': {
            color: '#FE9920'
        }
    },
    headerIcon: {
        marginRight: '5px'
    },
    link: {
        textDecoration: 'none',
        color: '#FFFFF2'
    }
}))
